// Constants for Azure Search filter field names and key re-use.
import { StringConstants } from 'app/utils/constants';

export const FILTER_FIELDS = {
  status: 'Status',
  createdOn: 'CreatedOn',
  deviceModels: 'DeviceModels',
  deviceModelName: 'Name',
  customerImpacts: 'CustomerImpacts',
  customerCountry: 'CustomerCountry',
  countryName: 'Name',
  isParent: 'IsParent'
} as const;

export const RELATIONSHIP_KEYS = {
  parent: 'parent',
  child: 'child',
  all: StringConstants.ALL
} as const;

export const AGING_KEYS = {
  sevenDays: '0d-7d',
  thirtyDays: '8d-30d',
  thirtyOnePlus: '31d-plus',
  all: StringConstants.ALL
} as const;

export const isAllKey = (key?: string | number) => key === StringConstants.ALL;
